import { useTranslation } from 'react-i18next';

interface ErrorFallbackProps {
  readonly error: unknown;
  readonly resetError: () => void;
}

export function ErrorFallback({ resetError }: ErrorFallbackProps) {
  const { t } = useTranslation('common');

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface">
      <div className="max-w-md space-y-4 p-8 text-center">
        <h1 className="text-display-xs font-bold text-error-primary">{t('errorFallback.title')}</h1>
        <p className="text-tertiary">{t('errorFallback.description')}</p>
        <button
          className="rounded bg-brand-solid px-4 py-2 text-white hover:bg-brand-solid_hover"
          type="button"
          onClick={resetError}
        >
          {t('actions.retry')}
        </button>
      </div>
    </div>
  );
}
